/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20201003T040000Z%2F20201003T060000Z&text=Dinda+%26+Indra+Wedding&details=Dinda+%26+Indra+Wedding`;
export const GOOGLE_MAPS_LINK = `https://goo.gl/maps/azmXNUjgPkuk9oih7`;


/**
 * Wedding time
 */
export const EPOCH_START_EVENT = 1698609696;
export const EPOCH_END_EVENT = 1698609696;


